import { Tab, Tabs } from '@mui/material';
import type { OrigenDescarga } from '../lib/api.js';

/** Dos listas y no una: lo que se pidió desde Buscar o la watchlist, y lo que se pidió
 *  desde la revisión de la biblioteca (D-28) —un fichero de Plex pasando por el conversor,
 *  o una versión mejor de HispaShare que va a sustituirlo—. Mezclado en una sola lista se
 *  leía mal: una película «desde la biblioteca» entre descargas a medias parecía una
 *  descarga más.
 *
 *  Se pinta siempre, aunque una de las dos esté vacía: escondida cuando no había nada de la
 *  biblioteca, la pestaña «no aparecía» y nadie sabía dónde buscarla. */
export function SelectorOrigen({
  valor,
  onCambio,
  cuentas,
}: {
  valor: OrigenDescarga;
  onCambio: (v: OrigenDescarga) => void;
  cuentas: Record<OrigenDescarga, number>;
}) {
  return (
    <Tabs value={valor} onChange={(_e, v: OrigenDescarga) => onCambio(v)} sx={{ minHeight: 36 }}>
      <Tab value="hispashare" label={`Descargas · ${cuentas.hispashare}`} sx={{ minHeight: 36, py: 0 }} />
      <Tab value="biblioteca" label={`Desde la biblioteca · ${cuentas.biblioteca}`} sx={{ minHeight: 36, py: 0 }} />
    </Tabs>
  );
}

/** Con qué pestaña arrancar: la de descargas, salvo que esté vacía y la otra no. */
export function origenInicial(cuentas: Record<OrigenDescarga, number>): OrigenDescarga {
  return cuentas.hispashare === 0 && cuentas.biblioteca > 0 ? 'biblioteca' : 'hispashare';
}

/** De dónde se pidió, que no es lo mismo que de dónde viene el fichero: una película vuelta
 *  a descargar desde Biblioteca es una descarga de HispaShare con la sustitución apuntada,
 *  y va con las de la biblioteca porque es ahí donde se decidió. */
export function pestanaDe(i: { origen: OrigenDescarga; sustituyeRuta?: string | null }): OrigenDescarga {
  return i.origen === 'biblioteca' || i.sustituyeRuta ? 'biblioteca' : 'hispashare';
}

export function contarOrigenes<T extends { origen: OrigenDescarga; sustituyeRuta?: string | null }>(
  items: T[],
): Record<OrigenDescarga, number> {
  return {
    hispashare: items.filter((i) => pestanaDe(i) === 'hispashare').length,
    biblioteca: items.filter((i) => pestanaDe(i) === 'biblioteca').length,
  };
}
